/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useState, useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line no-unused-vars
import { Modal, Collapse, Form, Row, Col, Input, Select, message } from 'antd';
import { MONITOREO_TERMINADO } from 'constants/estatusMonitoreo';
import { Button, Tooltip, Accordion } from 'components';
import { DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
// import { scrollToErrorField } from 'utils/form/scollToErrorFiled';
import {
  newScrollToErrorField,
  encontrarActiveKeyPorValor
} from 'utils/form/newScrollToErrorField';
import { MediosImpContext } from 'contexts/MediosImpContext';
import { videoSamples, splitBase64 } from 'utils/fileVideosBase64Parts';
import { showAlert } from 'actions/alert.actions';
import { DATE_STRING_TO_MOMENT } from 'utils/date';
import { upsertMonitoreosMediosImp, sendPartVideosInternet } from 'actions/monitoreos.actions';
import './ModalNvoMedImp.scss';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import {
  BENEFICIADOS,
  PROCESOS_ELECTORALES,
  TIPO_BENEFICIO,
  TIPO_MONITOREOS
} from 'constants/nombresCatalogos';
import { FORMAT_BACKEND } from 'constants/dateFormat';
import InfoModal from 'components/InfoModal/InfoModal';
import * as fieldMsgs from 'constants/formFieldsMessages';
import Beneficiados from 'containers/Beneficiados/Beneficiados';
import Muestras from './components/Muestras';
import DatosGenerales from './components/DatosGenerales';
import DatosHallazgo from './components/DatosHallazgo';
import Observaciones from './components/Observaciones';

// MNI - Llamado a generación de PDF
import { generarPDFMonitoreos } from 'services/monitoreos.service';

moment.locale('esES');
/**
 * Modal para agregar nuevo monitoreo.
 */
function ModalNvoMedImp({ title, open, callback, catTipoMedioImp }) {
  const { Option } = Select;
  const [form] = Form.useForm();
  const now = moment();
  const dispatch = useDispatch();
  // const procesosElec = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const procesosCat = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const procesosElec = procesosCat.map((proceso) => ({
    ...proceso,
    nombreProcesoEspecifico: proceso?.nombreProcesoEspecifico?.replace('Ã±', 'ñ')
  }));
  const catTipoBeneficio = useSelector(selectCatalogByName(TIPO_BENEFICIO));
  const catBeneficiados = useSelector(selectCatalogByName(BENEFICIADOS));
  const catHallazgos = useSelector(selectCatalogByName(TIPO_MONITOREOS)); // <- antes hallazgosCat!!!
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [activeKey, setActiveKey] = useState([]);

  const [idProcesoGeneral, setIdProcesoGeneral] = useState(null);

  const identificadoresForm = {
    datos_generales: [
      'idEstado',
      'idProcesoEspecifico',
      'idMunicipio',
      'idAmbito',
      'idDistritoLoc',
      'idDistritoFed',
      'idPeriodo'
    ],
    muestras: ['muestra1', 'muestra2'],
    beneficiados: ['tipo_beneficio'],
    datosHallazgo: [
      'idTipoHallazgo',
      'idSubTipoHallazgo',
      'grupoEditorial',
      'seccion',
      'pagina',
      'fechaPublicacion',
      'idTipoMedida',
      'leyendaPagada',
      'responsablePago'
    ],
    observaciones: ['validacionCNCS', 'tipoValoracion', 'lema', 'valoraciones']
  };

  const catTipoAsociaciones = [];
  for (let i = 0; i < catBeneficiados.length; i += 1) {
    const objetoABuscar = {
      idTipoAsociacion: catBeneficiados[i].idTipoAsociacion,
      tipoAsociacion: catBeneficiados[i].tipoAsociacion
    };
    if (
      !catTipoAsociaciones.some((item) => JSON.stringify(item) === JSON.stringify(objetoABuscar))
    ) {
      catTipoAsociaciones.push(objetoABuscar);
    }
  }

  const catSujetosObligados = [];
  for (let i = 0; i < catBeneficiados.length; i += 1) {
    const objetoABuscar = {
      idSujetoObligado: catBeneficiados[i].idSujetoObligado,
      sujetoObligado: catBeneficiados[i].sujetoObligado
    };
    if (
      !catSujetosObligados.some((item) => JSON.stringify(item) === JSON.stringify(objetoABuscar))
    ) {
      catSujetosObligados.push(objetoABuscar);
    }
  }

  const catCargos = [];
  for (let i = 0; i < catBeneficiados.length; i += 1) {
    if (!catCargos.includes(catBeneficiados[i].cargo)) {
      catCargos.push(catBeneficiados[i].cargo);
    }
  }
  // 5
  // Fin muestras

  // Datos generales
  const [ambitoRadio, setAmbitoRadio] = useState(null);
  const [mostrarOtroPeriodo, setMostrarOtroPeriodo] = useState(false);
  const [inicioPeriodo, setInicioPeriodo] = useState(null);
  const [finPeriodo, setFinPeriodo] = useState(null);

  // Beneficiados
  const [showTableTipoBenef, setShowTableTipoBenef] = useState(null);
  const [dataBeneficiados, setDataBeneficiados] = useState([
    {
      key: 1
    }
  ]);

  // Fin columnas
  // Fin Beneficiados

  // Datos del hallazgo

  const [catNombreMedImp, setCatNombreMedImp] = useState(null);
  const [nombreMedImpEsOtro, setNombreMedImpEsOtro] = useState(false);
  // Fin Datos del hallazgo
  const [disabledBtnGenerar, setDisabledBtnGenerar] = useState(false);

  const handleCancel = () => {
    form.resetFields();
    setActiveKey([]);
    setDisabledBtnGenerar(false);
    callback(false);
    setIdProcesoGeneral(0);
  };

  function esTipoHallazgoOtro(idTipoHallazgo) {
    return catTipoMedioImp
      .find((medImp) => medImp.idHallazgo === idTipoHallazgo)
      ?.nombreHallazgo.includes('Otro');
  }

  function esSubTipoHallazgoOtro(idSubTipoHallazgo) {
    return catNombreMedImp
      .find((subHallazgo) => subHallazgo.idTipoHallazgo === idSubTipoHallazgo)
      ?.nombreTipoHallazgo.includes('Otro');
  }

  const concatValoraciones = (valoracionesString, valoracion, index) => {
    if (index === 0) {
      return `${valoracion}`;
    }
    return `${valoracionesString},${valoracion}`;
  };
  const [isLoading, setIsLoading] = useState(false);

  const processMuestras = async (muestrasOrdenadas) => {
    muestrasOrdenadas.map(async (m) => {
      if (m.muestra?.length > 1024 * 1024) {
        const parts = splitBase64(m.muestra, 1024 * 1024);
        parts.forEach(
          async (part, index) =>
            // eslint-disable-next-line no-return-await
            await sendPartVideosInternet(m.idMuestra, m.idHallazgo, index + 1, parts.length, part)
        );
      } else {
        await sendPartVideosInternet(m.idMuestra, m.idHallazgo, 1, 1, m.muestra);
      }
      return m;
    });
  };

  const formatoMuestrasHallazgos = (values) => {
    const hallazgosFormateados = [
      {
        pkHallazgo: 1,
        muestras: [
          {
            pkMuestra: 1,
            muestra: values?.muestra1?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          },
          {
            pkMuestra: 2,
            muestra: values?.muestra2?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          },
          {
            pkMuestra: 3,
            muestra: values?.muestra3?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          },
          {
            pkMuestra: 4,
            muestra: values?.muestra4?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          },
          {
            pkMuestra: 5,
            muestra: values?.muestra5?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          }
        ].filter((m) => m.muestra) // Quitamos los elementos que no tengan imagen
      }
    ];

    return hallazgosFormateados;
  };

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  // vincular todos los formularios
  const items = useMemo(
    () => [
      {
        key: 'muestras',
        label: 'Muestras',
        forceRender: true,
        children: <Muestras form={form} isLoading={isLoading} />
      },
      {
        key: 'datos_generales',
        label: 'Datos Generales',
        forceRender: true,
        children: (
          <DatosGenerales
            form={form}
            isLoading={isLoading}
            mostrarOtroPeriodo={mostrarOtroPeriodo}
            setMostrarOtroPeriodo={setMostrarOtroPeriodo} 
            setInicioPeriodo={setInicioPeriodo}
            setFinPeriodo={setFinPeriodo}
            idProcesoEsp = { idProcesoGeneral }
          />
        )
      },
      {
        key: 'beneficiados',
        label: 'Beneficiados',
        forceRender: true,
        children: (
          <Beneficiados
            form={form}
            isLoading={isLoading}
            renderBeneficiados={Math.floor(Math.random() * 100)}
            tipoBeneficioInicial={null}
            actionType
          />
        )
      },
      {
        key: 'datosHallazgo',
        label: 'Datos de Hallazgo',
        forceRender: true,
        children: (
          <DatosHallazgo
            form={form}
            catNombreMedImp={catNombreMedImp}
            setCatNombreMedImp={setCatNombreMedImp}
            nombreMedImpEsOtro={nombreMedImpEsOtro}
            setNombreMedImpEsOtro={setNombreMedImpEsOtro}
          />
        )
      },
      {
        key: 'observaciones',
        label: 'Observaciones',
        forceRender: true,
        children: <Observaciones form={form} />
      }
    ],
    [isLoading, form, mostrarOtroPeriodo, catNombreMedImp, idProcesoGeneral]
  );

  const getValoraciones = (valoracionesArray) => {
    let valoracionesString = '';
    if (valoracionesArray !== undefined) {
      let index = 0;
      valoracionesArray.forEach((valoracion) => {
        valoracionesString = concatValoraciones(valoracionesString, valoracion, index);
        index += 1;
      });
    }
    return valoracionesString;
  };

  const getTipoBeneficio = (tipoBeneficio) => {
    const tipoBeneficioObj = catTipoBeneficio.filter(
      (beneficio) => beneficio.idTipoBeneficio === tipoBeneficio
    )[0];
    return tipoBeneficioObj.idTipoBeneficio;
  };

  const onFinish = async () => 
  {
    let values = {};
    try 
    {
      values = await form.validateFields();
      if (values.beneficiados.length === 0) {
        dispatch(showAlert('Debes registrar al menos un beneficiado', ALERT_ERROR_TYPE));
        setActiveKey('beneficiados');
        return;
      }
    } catch (error) {
      const { errorFields } = error;
      console.log(error, 'Error*');
      if (errorFields) {
        const [firstError] = errorFields;
        const identifierForm = encontrarActiveKeyPorValor(
          identificadoresForm,
          firstError?.name?.[0]
        );
        if (identifierForm) {
          newScrollToErrorField(errorFields, form);
          setActiveKey([`${identifierForm}`]);
        } else {
          setActiveKey([`${newScrollToErrorField(errorFields, form)}`]);
        }
      }
      setIsLoading(false);
      return;
    }
    let idtipomedida = '';
    // eslint-disable-next-line array-callback-return
    catHallazgos[1].tiposMedida.map((x) => {
      // eslint-disable-next-line eqeqeq
      if (x.tipoMedida == values.idTipoMedida) {
        idtipomedida = x.idTipoMedida;
      }
    });
    setDisabledBtnGenerar(true); // activar!!
    // values.idEstado = 9;
    // Estructura
    const estructura = {
      pkMonitoreo: 1,
      idTipoMonitoreo: 2,
      estatusMonitoreo: MONITOREO_TERMINADO.value,
      idProcesoGral: values.idProcesoGral,
      descripcionProcesoGral: procesosElec.find(
        (proc) => proc.idProcesoElectoral === values.idProcesoGral
      )
        ? procesosElec.find((proc) => proc.idProcesoElectoral === values.idProcesoGral).descripcion
        : null,
      idTipoEleccion: procesosElec.find((proc) => proc.idProcesoElectoral === values.idProcesoGral)
        ? procesosElec.find((proc) => proc.idProcesoElectoral === values.idProcesoGral)
            .idTipoEleccion
        : null,
      idAmbito: values.idAmbito,
      idEstado: values.idEstado,
      tipoRegistro: 2,
      // idUsuario: 2,
      fechaRegistro: now.format(DATE_STRING_TO_MOMENT),
      notificarPartido: 0,
      hallazgos: [
        {
          pkHallazgo: 1,
          idProcesoEspecifico: values.idProcesoEspecifico,
          tipoRegistro: 2,
          estatus: 2,
          fechaCreacion: now.format(DATE_STRING_TO_MOMENT),
          idPeriodo: values.idPeriodo,
          idTipoHallazgo: values.idTipoHallazgo,
          idAmbito: values.idAmbito,
          inicioOtroPeriodo: values.otroPeriodo ? values.otroPeriodo[0].format('YYYY-MM-DD') : null,
          finOtroPeriodo: values.otroPeriodo ? values.otroPeriodo[1].format('YYYY-MM-DD') : null,
          tipoHallazgo: catTipoMedioImp.find(
            (medImp) => medImp.idHallazgo === values.idTipoHallazgo
          )
            ? catTipoMedioImp.find((medImp) => medImp.idHallazgo === values.idTipoHallazgo)
                .nombreHallazgo
            : null, // tipo de medio impreso  // ------> antes "nombre"

          otroTipoHallazgo: values.otroTipoHallazgo,
          idSubTipoHallazgo: esTipoHallazgoOtro(values.idTipoHallazgo)
            ? 0
            : values.idSubTipoHallazgo,
          subTipoHallazgo:
            esSubTipoHallazgoOtro(values.idSubTipoHallazgo) ||
            esTipoHallazgoOtro(values.tipoHallazgo)
              ? null
              : catNombreMedImp.find(
                  (subHallazgo) =>
                    subHallazgo.idTipoHallazgo === esSubTipoHallazgoOtro(values.idSubTipoHallazgo)
                )?.nombreTipoHallazgo,
          otroSubTipoHallazgo: values.otroSubTipoHallazgo,
          seccion: values.seccion,
          pagina: parseInt(values.pagina, 10),
          fechaPublicacion: form.getFieldValue('fechaPublicacion')?.format(FORMAT_BACKEND),
          idTipoMedida: values.idTipoMedida,
          // medida: values.idTipoMedida,
          editorial: values.grupoEditorial,
          leyendaPagada: values.leyendaPagada,
          tipoValoracion: values.tipoValoracion,
          tipoBeneficio: getTipoBeneficio(values.tipo_beneficio),
          valoraciones: getValoraciones(values.valoraciones),
          validacionCNCS: values.validacionCNCS,
          muestras: [],
          beneficiados: values.beneficiados.map((beneficiado) => ({
            ...beneficiado,
            pkBeneficiado: Math.floor(Math.random() * 9)
          }))
        }
      ]
    };
    // ======== Begin Muestras ======== //

    if (values.muestra1 !== undefined) {
      const m1 = {
        pkMuestra: 1,
        muestra:
          values.muestra1.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
          'data:video/mp4;base64'
            ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_1.mp4'
            : values.muestra1.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
      };
      estructura.hallazgos[0].muestras.push(m1);
    }

    if (values.muestra2 !== undefined) {
      const m2 = {
        pkMuestra: 2,
        muestra:
          values.muestra2.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
          'data:video/mp4;base64'
            ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_2.mp4'
            : values.muestra2.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
      };
      estructura.hallazgos[0].muestras.push(m2);
    }

    if (values.muestra3 !== undefined) {
      const m3 = {
        pkMuestra: 3,
        muestra:
          values.muestra3.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
          'data:video/mp4;base64'
            ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_3.mp4'
            : values.muestra3.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
      };
      estructura.hallazgos[0].muestras.push(m3);
    }

    if (values.muestra4 !== undefined) {
      const m4 = {
        pkMuestra: 4,
        muestra:
          values.muestra4.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
          'data:video/mp4;base64'
            ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_4.mp4'
            : values.muestra4.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
      };
      estructura.hallazgos[0].muestras.push(m4);
    }
    if (values.muestra5 !== undefined) {
      const m5 = {
        pkMuestra: 5,
        muestra:
          values.muestra5.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
          'data:video/mp4;base64'
            ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_5.mp4'
            : values.muestra5.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
      };
      estructura.hallazgos[0].muestras.push(m5);
    }
    // End muestras

    // Datos generales - Ambito -> Distritos
    if (ambitoRadio === 1) {
      estructura.hallazgos[0].idDistritoFed = parseInt(values.idDistritoFed, 10);
    } else if (ambitoRadio === 2) {
      estructura.hallazgos[0].idDistritoLoc = parseInt(values.idDistritoLoc, 10);
    } else {
      estructura.hallazgos[0].idDistritoFed = parseInt(values.idDistritoFed, 10);
      estructura.hallazgos[0].idDistritoLoc = parseInt(values.idDistritoLoc, 10);
    }

    if (mostrarOtroPeriodo) {
      estructura.hallazgos[0].inicioOtroPeriodo = inicioPeriodo;
      estructura.hallazgos[0].finOtroPeriodo = finPeriodo;
    }

    // Beneficiados
    let objAsociacion = null;
    let objSujetoObligado = null;
    let objBeneficiado = null;
    switch (showTableTipoBenef) {
      case 'Directo':
        objBeneficiado = catBeneficiados.find(
          (bene) => bene.nombreBeneficiado === form.getFieldValue('nombreBeneficiado-1')
        );
        if (objBeneficiado) {
          estructura.hallazgos[0].beneficiados.push({
            pkBeneficiado: 1,
            idTipoAsociacion: objBeneficiado.idTipoAsociacion,
            tipoAsociacion: objBeneficiado.tipoAsociacion,
            idSujetoObligado: objBeneficiado.idSujetoObligado,
            sujetoObligado: objBeneficiado.sujetoObligado,
            idContabilidad: objBeneficiado.idContabilidad,
            nombreBeneficiado: objBeneficiado.nombreBeneficiado,
            cargo: objBeneficiado.cargo
          });
        }
        break;
      case 'Personalizado':
        for (let h = 0; h < dataBeneficiados.length; h += 1) {
          objBeneficiado = catBeneficiados.find(
            (bene) =>
              bene.nombreBeneficiado ===
              form.getFieldValue(`nombreBeneficiado-${dataBeneficiados[h].key}`)
          );
          if (objBeneficiado) {
            estructura.hallazgos[0].beneficiados.push({
              pkBeneficiado: dataBeneficiados[h].key,
              idTipoAsociacion: objBeneficiado.idTipoAsociacion,
              tipoAsociacion: objBeneficiado.tipoAsociacion,
              idSujetoObligado: objBeneficiado.idSujetoObligado,
              sujetoObligado: objBeneficiado.sujetoObligado,
              idContabilidad: objBeneficiado.idContabilidad,
              nombreBeneficiado: objBeneficiado.nombreBeneficiado,
              cargo: objBeneficiado.cargo
            });
          }
        }
        break;
      case 'Conjunto':
        for (let i = 0; i < dataBeneficiados.length; i += 1) {
          objAsociacion = catTipoAsociaciones.find(
            (asociacion) =>
              asociacion.tipoAsociacion ===
              form.getFieldValue(`tipoAsociacion-${dataBeneficiados[i].key}`)
          );
          objSujetoObligado = catSujetosObligados.find(
            (sujeto) =>
              sujeto.sujetoObligado ===
              form.getFieldValue(`sujetoObligado-${dataBeneficiados[i].key}`)
          );
          const newBene = {
            pkBeneficiado: dataBeneficiados[i].key,
            idTipoAsociacion: objAsociacion?.idTipoAsociacion,
            tipoAsociacion: form.getFieldValue(`tipoAsociacion-${dataBeneficiados[i].key}`),
            idSujetoObligado: objSujetoObligado?.idSujetoObligado,
            sujetoObligado: form.getFieldValue(`sujetoObligado-${dataBeneficiados[i].key}`),
            cargo: form.getFieldValue(`cargo-${dataBeneficiados[i].key}`)
          };
          estructura.hallazgos[0].beneficiados.push(newBene);
        }
        break;
      case 'Genérico':
        objAsociacion = catTipoAsociaciones.find(
          (asociacion) => asociacion.tipoAsociacion === form.getFieldValue('tipoAsociacion')
        );
        objSujetoObligado = catSujetosObligados.find(
          (sujeto) => sujeto.sujetoObligado === form.getFieldValue('sujetoObligado')
        );
        estructura.hallazgos[0].beneficiados.push({
          pkBeneficiado: 1,
          idTipoAsociacion: objAsociacion?.idTipoAsociacion,
          tipoAsociacion: form.getFieldValue('tipoAsociacion'),
          idSujetoObligado: objSujetoObligado?.idSujetoObligado,
          sujetoObligado: form.getFieldValue('sujetoObligado')
        });
        break;
      default:
        setDataBeneficiados([]);
        break;
    }
    // Fin beneficiados

    // Datos hallazgo - nombre del medio impreso
    if (nombreMedImpEsOtro) {
      estructura.hallazgos[0].otroSubTipoHallazgo = values.otroSubTipoHallazgo;
    }

    // Cantidad - Datos de hallazgo
    if (values.cantidad) {
      estructura.hallazgos[0].cantidad = parseInt(values.cantidad, 10);
    }

    // Tipo de medida
    if (values.idTipoMedida === 44) {
      estructura.hallazgos[0].otraMedida = values.otraMedida;
    }

    // leyenda pagada: Responsable de pago
    if (values.leyendaPagada) {
      estructura.hallazgos[0].responsablePago = values.responsablePago;
    }

    // Observaciones: lema (Propaganda)
    if (values.tipoValoracion === 1) {
      if (values.lema) {
        estructura.hallazgos[0].lema = values.lema;
      }
    } else {
      estructura.hallazgos[0].valoraciones = values.valoraciones?.toString();
    }

    // Observaciones: Información adicional
    if (values.infAdicional) {
      estructura.hallazgos[0].infAdicional = values.infAdicional;
    }

    const data = {
      monitoreos: {
        toSave: []
      }
    };
    data.monitoreos.toSave.push(estructura);
    const { success, hallazgos: hallazgosMonitoreo, idMonitoreo } = await dispatch(
      upsertMonitoreosMediosImp(data)
    );

    let idNewMonitoreo = 0;

    if (success) 
    {
      // Obtenemos el id del nuevo monitoreo generado
      idNewMonitoreo  = idMonitoreo;

      // Variable a enviar para generar PDF del monitoreo
      let monitoreoPDF = [{
          idMonitoreo     : idNewMonitoreo
        , idTipoMonitoreo : 2
        , tiposActa       : [{ "id": 4 }]
      }];

      const hallazgos = formatoMuestrasHallazgos(values);
      const muestrasOrdenadas = videoSamples(hallazgosMonitoreo, hallazgos);

      if (muestrasOrdenadas.length > 0) 
      {
        await processMuestras(muestrasOrdenadas)
          .then(async () => 
          {
            setDisabledBtnGenerar(false);
            setIsVisibleSuccessModal(true);
            form.resetFields();

            // Se genera PDF una vez que se han almacenado las Muestras
            let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

            if(generoPDF)
            {
              console.log('Se generó correctamente el PDF');
            }else{
              console.log('Error al generar el PDF');
            }

            callback();
            setIdProcesoGeneral(0);
          })
          .catch((error) => {
            console.error('Error procesando las muestras:', error);
          });
      } else 
      {
        setDisabledBtnGenerar(false);
        setIsVisibleSuccessModal(true);
        form.resetFields();

        // Se genera PDF una vez que se han almacenado las Muestras
        let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

        if(generoPDF)
        {
          console.log('Se generó correctamente el PDF');
        }else{
          console.log('Error al generar el PDF');
        }

        callback();
        setIdProcesoGeneral(0);
      }
    } else {
      setDisabledBtnGenerar(false);
    }
  };

  const handleIdProcesoGralChange = (e) => 
  {
    try 
    {
      setIdProcesoGeneral(e); 
    } catch (error) 
    {
      console.log('Error: ', error);  
    }
  };

  return (
    <>
      <InfoModal visible={isVisibleSuccesModal} onClose={() => setIsVisibleSuccessModal(false)} />
      <Modal
        title={title}
        open={open}
        onCancel={handleCancel}
        onOk={onFinish}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { marginLeft: '-1em' }, disabled: disabledBtnGenerar }}
        okText="Generar monitoreo"
        centered
        width="85%"
        className="modal-med-imp">
        <div>
          <div className="div-instrucciones">
            <span style={{ color: '#9159CB' }}>Captura la información solicitada.</span>
            <span style={{ color: 'red' }}>*Campos obligatorios.</span>
          </div>
        </div>
        <Form id="formNvoMedImp" className="form-med-imp" layout="vertical" form={form}>
          <div className="div-procesoe">
            <Form.Item
              name="idProcesoGral"
              label="Proceso Electoral:"
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
              <Select placeholder="Selecciona un proceso"
                onSelect={handleIdProcesoGralChange}
              >
                {procesosElec?.length > 0
                  ? procesosElec.map((data) => (
                      <Option key={data.idProcesoElectoral} value={data.idProcesoElectoral}>
                        {data.descripcion}
                      </Option>
                    ))
                  : null}
                  
              </Select>
            </Form.Item>
          </div>
        </Form>
        <Accordion
          items={items}
          className="modal-formulario-secciones"
          activeKey={activeKey}
          onChange={handleCollapseChange}
        />
      </Modal>
    </>
  );
}

export default ModalNvoMedImp;
